type Props = {
  count: number
  className?: string
}

export const BellBadge = ({ count, className = "" }: Props) => {
  if (count <= 0) return null
  const display = count > 99 ? "99+" : String(count)
  return (
    <span
      aria-hidden
      className={`absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full bg-brand-500 text-white text-[10px] font-bold leading-none flex items-center justify-center shadow-sm ring-2 ring-white ${className}`}
    >
      {display}
    </span>
  )
}
